import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Bootstrap app first - PostHog loads in background after app is ready
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    // Load analytics AFTER app is interactive (non-blocking)
    if (typeof window !== 'undefined') {
      import('posthog-js')
        .then(({ default: posthog }) => {
          posthog.init(environment.POSTHOG_KEY, {
            api_host: environment.POSTHOG_HOST,
            person_profiles: 'identified_only',
          });
        })
        .catch(() => {
          // Analytics failure should not break the app
        });
    }
  })
  .catch(() => {});
